import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Loading from "./Loading";

export const TenantDetailsLoading = () => {
  const pairs = Array(4).fill(0);
  const title = Array(3).fill(0);
  return (
    <div>
        <div className={`${styles.loadingContainer} gap-4 items-center`}>
          <div>
            <Skeleton height={90} width={90} borderRadius={50} />
          </div>
          <div>
            <div style={{ marginBottom: "8px" }}>
              <Skeleton height={15} width={500} />
            </div>
            <div className={styles.loadingContainer}>
              {pairs.map((_, index) => (
                <div key={index} style={{ marginRight: "16px" }}>
                  <div style={{ marginBottom: "5px" }}>
                    <Skeleton height={15} width={100} />
                  </div>
                  <div>
                    <Skeleton height={15} width={80} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      <div className={`${styles.loadingContainer} ml-4 gap-4 mt-4`}>
        {title.map((_, index) => (
          <div key={index}>
            <div>
              <Skeleton height={22} width={100} borderRadius={50} />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.activeLoadingContainer}>
        <Loading />
      </div>
    </div>
  );
};
const styles = {
  loadingContainer: "flex dispay-flex flex-row ",
  activeLoadingContainer: "justify-center flex flex-col items-center",
};
